import { useEffect, useState } from 'react';

import Input from '../../components/Input';
import Button from '../../components/Button';

import { usePlayer } from '../../context/PlayerContext';
import { useRoom } from '../../context/RoomContext';

export default function Game() {
  const { questions } = useRoom();
  const { quantityOfSolvedQuestions, submitAnswer } = usePlayer();

  const [answer, setAnswer] = useState<string>('');

  const handleSubmitAnswer = () => {
    submitAnswer(answer);
    setAnswer('');
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      handleSubmitAnswer();
    }
  };

  return (
    <div className="flex flex-col justify-center items-center gap-2">
      <h3 className=" text-slate-500 text-lg font-bold">
        Questão {quantityOfSolvedQuestions + 1} / {questions.length}
      </h3>

      <h1 className="mb-2">
        {questions[quantityOfSolvedQuestions].firstValue}{' '}
        {questions[quantityOfSolvedQuestions].operation}{' '}
        {questions[quantityOfSolvedQuestions].secondValue}
      </h1>

      <Input
        name=""
        id="answer"
        placeholder="Digite a resposta"
        value={answer}
        setValue={setAnswer}
        onKeyDown={handleKeyDown}
        autoFocus
      />

      <Button onClick={() => handleSubmitAnswer()}>Enviar</Button>
    </div>
  );
}
